import React from 'react';
import styled from 'styled-components';
import { Text } from '@alefeducation/ui-elements-library-core';
import { ACTIVE, INACTIVE } from '../../utils/constants';

interface Props {
  isActive: boolean;
}

const Indicator = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: ${({ theme: { space } }: any) => `${space[8]}px`};
`;

const ActiveIndicator = styled(Indicator)`
  background-color: ${({ theme }: any) => theme.colors.success[100]};
`;

const InActiveIndicator = styled(Indicator)`
  background-color: ${({ theme }: any) => theme.colors.primary[20]};
`;

const Status = ({ isActive }: Props) => {
  return (
    <React.Fragment>
      {isActive ? (
        <ActiveIndicator data-testid="activeIndicator" />
      ) : (
        <InActiveIndicator data-testid="inactiveIndicator" />
      )}
      <Text
        variant="body-large"
        color="primary.100"
        weight="light"
        data-testid={'organisation-row-field-status'}
      >
        {isActive ? ACTIVE : INACTIVE}
      </Text>
    </React.Fragment>
  );
};

export default Status;
